import { z } from 'zod';

export const SkillSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  name: z.string(),
  description: z.string().nullable(),
  active: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Skill = z.infer<typeof SkillSchema>;

const SkillBody = z.object({
  name: z.string().min(1).max(120),
  description: z.string().nullable().optional(),
  active: z.boolean().optional(),
});

export const CreateSkillInput = SkillBody;
export type CreateSkillInput = z.infer<typeof CreateSkillInput>;

export const PatchSkillInput = SkillBody.partial();
export type PatchSkillInput = z.infer<typeof PatchSkillInput>;

export interface ListSkillsQuery {
  q?: string;
  active?: boolean;
  sortField?: 'name' | 'createdAt' | 'updatedAt';
  sortDirection?: 'asc' | 'desc';
  limit?: number;
  offset?: number;
}
